"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupApps = exports.GroupAppKeyToTab = exports.TabToGroupAppKey = exports.Tab = void 0;
var types_1 = require("@wix/ambassador-social-groups-v1-group-app/types");
var Tab;
(function (Tab) {
    Tab["DISCUSSION"] = "discussion";
    Tab["MEDIA"] = "media";
    Tab["MEMBERS"] = "members";
    Tab["ABOUT"] = "about";
    Tab["EVENTS"] = "events";
    Tab["CUSTOM"] = "custom";
})(Tab = exports.Tab || (exports.Tab = {}));
exports.TabToGroupAppKey = (_a = {},
    _a[Tab.DISCUSSION] = types_1.GroupAppKey.FEED_APP,
    _a[Tab.ABOUT] = types_1.GroupAppKey.ABOUT_APP,
    _a[Tab.MEMBERS] = types_1.GroupAppKey.MEMBERS_APP,
    _a[Tab.MEDIA] = types_1.GroupAppKey.GALLERY_APP,
    _a[Tab.EVENTS] = types_1.GroupAppKey.EVENTS_APP,
    _a[Tab.CUSTOM] = types_1.GroupAppKey.CUSTOM_APP,
    _a);
exports.GroupAppKeyToTab = (_b = {},
    _b[types_1.GroupAppKey.FEED_APP] = Tab.DISCUSSION,
    _b[types_1.GroupAppKey.ABOUT_APP] = Tab.ABOUT,
    _b[types_1.GroupAppKey.MEMBERS_APP] = Tab.MEMBERS,
    _b[types_1.GroupAppKey.GALLERY_APP] = Tab.MEDIA,
    _b[types_1.GroupAppKey.EVENTS_APP] = Tab.EVENTS,
    _b[types_1.GroupAppKey.CUSTOM_APP] = Tab.CUSTOM,
    _b);
var appsOrder = (_c = {},
    _c[types_1.GroupAppKey.FEED_APP] = 0,
    _c[types_1.GroupAppKey.GALLERY_APP] = 1,
    _c[types_1.GroupAppKey.MEMBERS_APP] = 2,
    _c[types_1.GroupAppKey.ABOUT_APP] = 3,
    _c[types_1.GroupAppKey.EVENTS_APP] = 4,
    _c[types_1.GroupAppKey.CUSTOM_APP] = 5,
    _c);
var GroupApps = /** @class */ (function () {
    function GroupApps(apps) {
        this.apps = apps.sort(function (a, b) {
            // JS 0 vs undefined hack
            var k1 = appsOrder[a.key] + 1 || Infinity;
            var k2 = appsOrder[b.key] + 1 || Infinity;
            return k1 - k2;
        });
    }
    GroupApps.fromAppsMap = function (appsMap) {
        var groupApps = new GroupApps(Object.values(appsMap));
        groupApps.appsMap = appsMap;
        return groupApps;
    };
    GroupApps.prototype.getAppsMap = function () {
        if (!this.appsMap) {
            this.appsMap = this.apps.reduce(function (acc, app) {
                acc[app.key] = app;
                return acc;
            }, {});
        }
        return this.appsMap;
    };
    GroupApps.prototype.getNames = function () {
        return this.apps.map(function (app) {
            return app.customName || exports.GroupAppKeyToTab[app.key];
        });
    };
    GroupApps.prototype.getTabsMap = function (translation) {
        var _this = this;
        return this.apps.reduce(function (acc, app) {
            var t = translation && translation[_this.getTranslationKey(app)];
            var tab = exports.GroupAppKeyToTab[app.key];
            acc[tab] = app.customName || t || tab;
            return acc;
        }, {});
    };
    GroupApps.prototype.getApps = function () {
        return this.apps;
    };
    GroupApps.prototype.getInstalledApps = function () {
        if (!this.installedApps) {
            this.installedApps = this.apps.filter(function (app) { return app.installed; });
        }
        return this.installedApps;
    };
    GroupApps.prototype.getVisibleTabs = function () {
        var installedApps = this.getInstalledApps();
        return installedApps.map(function (app) { return exports.GroupAppKeyToTab[app.key]; });
    };
    GroupApps.prototype.getTranslationKey = function (app, prefix) {
        if (prefix === void 0) { prefix = 'groups-web.'; }
        return app.customName || "" + prefix + exports.GroupAppKeyToTab[app.key];
    };
    GroupApps.prototype.isTabInstalled = function (tab) {
        var appKey = exports.TabToGroupAppKey[tab];
        var appsMap = this.getAppsMap();
        var groupApp = appsMap[appKey];
        return groupApp && groupApp.installed;
    };
    GroupApps.prototype.isMembersTabInstalled = function () {
        return this.isTabInstalled(Tab.MEMBERS);
    };
    return GroupApps;
}());
exports.GroupApps = GroupApps;
//# sourceMappingURL=GroupApps.js.map